import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

let stompClient: Client | null = null;

export function connectWebSocket(postId: string, onMessage: (data: any) => void) {
    const socket = new SockJS("https://api.eblcraft.it/ws"); // ✅ endpoint corretto
    stompClient = new Client({
        webSocketFactory: () => socket,
        reconnectDelay: 5000,
        onConnect: () => {
            console.log("🟢 WebSocket connesso");
            stompClient?.subscribe(`/topic/report/${postId}`, (msg) => {
                const data = JSON.parse(msg.body);
                onMessage(data);
            });
        },
        onStompError: (frame) => {
            console.error("WebSocket error:", frame.headers['message']);
        }
    });

    stompClient.activate();
}

export function disconnectWebSocket() {
    if (stompClient?.connected) {
        stompClient.deactivate();
        console.log("🔴 WebSocket disconnesso");
    }
}